import URLS from './modules/urls';
import { LANGUAGE_LIST, LANGUAGE_LOCALE_MAPPING } from './modules/language-list';
import NAV_LIST from './modules/nav-list';
const LOGIN_EXPIRES = 5; // 天
export { URLS, LOGIN_EXPIRES, LANGUAGE_LIST, LANGUAGE_LOCALE_MAPPING, NAV_LIST, };
